"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ampApi = require("@amplify/amp-api");

var _realtimeService = _interopRequireDefault(require("./realtimeService"));

var _constants = require("../shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AutosaveNotificationService = /*#__PURE__*/function () {
  function AutosaveNotificationService() {
    (0, _classCallCheck2.default)(this, AutosaveNotificationService);
  }

  (0, _createClass2.default)(AutosaveNotificationService, [{
    key: "addListener",
    value: function () {
      var _addListener = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(classKey, userKeys, cardstackKeys, callback) {
        var _this = this;

        var initialAutosaves, batchedNotifications, batchTimeoutId, clearBatch, notificationCallback;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchBulkAutosaves(userKeys, cardstackKeys);

              case 2:
                initialAutosaves = _context2.sent;
                callback(initialAutosaves); // autosave updates are batched since they can be triggered at high frequency

                batchedNotifications = [];
                batchTimeoutId = null; // pull the set of autosaves for the current batch of updates

                clearBatch = /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                    var batchedUserKeys, batchedCardstackKeys, updatedAutosaves;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            // the autosave service expects separate user and cardstack arrays
                            // and fetches the full span of each - note this could be optimized in the service to
                            // ensure we're only pulling the autosaves that have changed.
                            batchedUserKeys = _lodash.default.uniq(batchedNotifications.map(function (entry) {
                              return entry.userKey;
                            }));
                            batchedCardstackKeys = _lodash.default.uniq(batchedNotifications.map(function (entry) {
                              return entry.cardstackKey;
                            })); // clear out current batch

                            batchedNotifications = [];
                            batchTimeoutId = null;
                            _context.next = 6;
                            return _this.fetchBulkAutosaves(batchedUserKeys, batchedCardstackKeys);

                          case 6:
                            updatedAutosaves = _context.sent;
                            callback(updatedAutosaves);

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function clearBatch() {
                    return _ref.apply(this, arguments);
                  };
                }();

                notificationCallback = function notificationCallback(channel, payload, publisher) {
                  // ignore notifications for users or class keys we don't care about
                  if (channel !== classKey || !userKeys.includes(publisher)) {
                    return;
                  }

                  if (!payload || !payload.cardstackKey || !cardstackKeys.includes(payload.cardstackKey)) {
                    return;
                  } // if we haven't got an active timeout to trigger the batch update do it here


                  if (!batchTimeoutId) {
                    batchTimeoutId = setTimeout(clearBatch, _constants.AUTOSAVE_BATCH_TIME);
                  }

                  var found = batchedNotifications.find(function (entry) {
                    return entry.userKey === publisher && entry.cardstackKey === payload.cardstackKey;
                  });

                  if (!found) {
                    batchedNotifications.push({
                      userKey: publisher,
                      cardstackKey: payload.cardstackKey
                    });
                  }
                };

                _realtimeService.default.addEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_AUTOSAVE, notificationCallback, callback);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addListener(_x, _x2, _x3, _x4) {
        return _addListener.apply(this, arguments);
      }

      return addListener;
    }()
  }, {
    key: "removeListener",
    value: function removeListener(callback) {
      _realtimeService.default.removeEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_AUTOSAVE, callback);
    }
  }, {
    key: "publishNotification",
    value: function publishNotification(classKey, cardstackKey, recipient) {
      return _realtimeService.default.publish(classKey, _constants.STUDENT_RECORD_TYPES.STUDENT_AUTOSAVE, {
        cardstackKey: cardstackKey
      }, recipient);
    }
  }, {
    key: "fetchBulkAutosaves",
    value: function () {
      var _fetchBulkAutosaves2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(userKeys, cardstackKeys) {
        var autosaves;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _ampApi.fetchBulkAutosaves)(userKeys, cardstackKeys, true);

              case 2:
                autosaves = _context3.sent;
                return _context3.abrupt("return", autosaves.map(function (autosave) {
                  return _objectSpread(_objectSpread({}, autosave), {}, {
                    userKey: autosave.fileUserKey
                  });
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function fetchBulkAutosaves(_x5, _x6) {
        return _fetchBulkAutosaves2.apply(this, arguments);
      }

      return fetchBulkAutosaves;
    }()
  }]);
  return AutosaveNotificationService;
}();

var _default = new AutosaveNotificationService();

exports.default = _default;
//# sourceMappingURL=autosaveNotificationService.js.map